import React from "react"
import { makeStyles, InputLabel, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: '12px'
    }
}));

export default function InputTextarea(props) {
    const classes = useStyles();

    return (
        <>
            {props.label ? <InputLabel htmlFor={props.id} className={classes.label}>{props.label}</InputLabel> : null}
            <div>
                <TextField 
                    type="text"
                    multiline
                    fullWidth
                    rows={props.rows}
                    id={props.id}
                    value={props.value}
                    onChange={(e) => { props.onChange(e.target.value) }}
                    variant="outlined"
                    disabled={props.disabled}
                    error={props.hasError}
                    helperText={props.errorText}
                    autoFocus={props.autoFocus}
                />
            </div>
        </>
    )
}